module.exports = __webpack_public_path__ + "img/mask-top.b69746e7.png";